import { jsxs as d, jsx as p } from "react/jsx-runtime";
import f from "clsx";
import { forwardRef as E, useRef as j } from "react";
import t from "./Input.module.css.js";
import { useInputErrorMessages as I } from "../InputErrorMessage/useInputErrorMessages.js";
import { Flex as O } from "../Flex/Flex.js";
import { IconButton as b } from "../IconButton/IconButton.js";
import { Close as x } from "../../foundations/icons/Close.js";
import { InputErrorMessage as C } from "../InputErrorMessage/InputErrorMessage.js";
const N = (r) => Array.isArray(r) ? r.length === 0 : r === void 0 || r === "", P = (r, o) => {
  const { set: n } = Object.getOwnPropertyDescriptor(r, "value") || {}, s = Object.getPrototypeOf(r), { set: e } = Object.getOwnPropertyDescriptor(s, "value") || {};
  if (e && n !== e)
    e.call(r, o);
  else if (n)
    n.call(r, o);
  else
    throw new Error("The given element does not have a value setter");
  r.dispatchEvent(new Event("change", { bubbles: !0 }));
}, D = E(
  ({
    autoFocus: r = !1,
    clearable: o = !1,
    error: n = !1,
    disabled: s = !1,
    inputSize: e = "default",
    prefix: m,
    suffix: g,
    onChange: y,
    value: h,
    className: v,
    ...w
  }, a) => {
    const c = j(null), { isInvalid: u, errorMessages: l } = I(n);
    return /* @__PURE__ */ d("div", { className: f(t.container, v), children: [
      /* @__PURE__ */ d(
        O,
        {
          align: "center",
          gap: 1,
          wrap: "nowrap",
          onClick: () => {
            c.current?.focus();
          },
          className: f(t.inputContainer, {
            [t.inputError]: u,
            [t.inputDisabled]: s,
            [t[e]]: e,
            [t.hasPrefix]: !!m,
            [t.hasSuffix]: o || !!g
          }),
          children: [
            m,
            /* @__PURE__ */ p(
              "input",
              {
                ref: (i) => {
                  c.current = i, a && ("current" in a ? a.current = i : typeof a == "function" && a(i));
                },
                onChange: y,
                value: h,
                "aria-invalid": u,
                "aria-errormessage": l.length > 0 ? l.map((i) => i.id).join(" ") : void 0,
                disabled: s,
                className: f(t.input, {
                  [t[e]]: e,
                  [t.inputError]: u
                }),
                ...w
              }
            ),
            g,
            o && !N(h) && /* @__PURE__ */ p(
              b,
              {
                ariaLabel: "Clear value",
                disabled: s,
                onClick: () => {
                  c.current && P(c.current, "");
                },
                children: /* @__PURE__ */ p(x, {})
              }
            )
          ]
        }
      ),
      l.length > 0 && /* @__PURE__ */ p(C, { children: l })
    ] });
  }
);
D.displayName = "Input";
export {
  D as Input
};
//# sourceMappingURL=Input.js.map
